import { render, staticRenderFns } from "./ItemsDropdown.vue?vue&type=template&id=5ec18518&lang=pug&"
import script from "./ItemsDropdown.vue?vue&type=script&lang=js&"
export * from "./ItemsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ItemsDropdown.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports